module.exports = __webpack_public_path__ + "static/people_img18-dadf2827a0dc02af7ebca452fcf78c02.png";